/**
 * Created by yangxx on 2017/10/21.
 * 定义带引线的dom
 */
'use strict';
define([
    '../../base/Class',
    '../../utils/CommonUtil',
    '../../utils/MathUtil',
    '../../utils/RenderUtil',
    '../../utils/SpatialOPUtil',
    '../../utils/GeometryUtil',
    '../../utils/LoggerUtil',
    '../../misc/AppEvent',
    '../../g2'
], function(Class,
    CommonUtil,
    MathUtil,
    RenderUtil,
    SpatialOPUtil,
    GeometryUtil,
    LoggerUtil,
    AppEvent,
    g2) {
    var TailedPopup = Class.extend({
        options: {
            //dom容器id
            domContainer: 'emap-taileddiv-container',
            //
            tailLength: 100,
            //连线在dom上的位置
            //箭头角度
            tailAngle: 45,
            //箭头
            showArrow: false,
            //箭头与线夹角单位度
            arrowAngle: 30,
            //箭头与引线长度比
            arrowScale: 0.3,
            //箭头长度
            arrowLength: NaN,
            //箭头符号
            arrowSymbol: false,
            //箭头形状
            arrowShape: 'triangle',
            //dom最小高度
            minHeight: 15,
            minWidth: 50,
            symbol: {
                "type": "SimpleLineSymbol",
                "options": {
                    "color": {
                        "a": 200,
                        "r": 0,
                        "g": 0,
                        "b": 255
                    },
                    "style": "5",
                    "width": 1
                }
            },
            //dom 的标签
            domTag: 'div',
            //dom padding [left,top,right,bottom] 每个标注的上下左右的缓冲空白区域大小
            domMinGap: [5, 5, 5, 5],
            domHtml: "新建引线文本",
            mousedownTime: null,
            mouseUpTime: null
        },
        includes: AppEvent.prototype,
        /**
         *
         * @param options
         * @param options.map {G.Map}　－　必填，地图对象
         * @param options.layer {g2.lys.Layer} -必填，图层
         * @param options.label {String} -　必填，文本内容
         * @param options.geometry {wkt/GeoJSON} －　必填，引线指向图形坐标，要求坐标系与map一致
         * @param options.tailLength {Number} - 必填，引线长度，单位像素
         * @param options.tailAngle {Number} -必填，引线与所指图形上的锚点的正北方向沿顺时针方向的夹角，单位度
         * @param options.symbol {Object} -可选，引线样式
         * @param options.showArrow {Boolean} -可选，是否显示箭头，默认为false
         * @param options.arrowSymbol {Object} -可选，箭头样式，默认与引线样式一致
         * @param options.arrowShape {String} -可选，箭头形状，默认为'triangle'，
         *          可选值为'line'=线、'triangle'=三角形
         * @param options.arrowLength {Number} 可选，箭头长度
         * @param options.arrowScale {Number} 可选，箭头长与线段长度比，默认为0.2；
         *          只有未指定arrowLength参数的情况下此参数才有效；
         * @param options.arrowAngle {Number} 可选，箭头与线段夹角，单位为度，默认为30度
         * @param options.domId {String} -可选，容器id，默认自动生成uuid
         * @param options.domClassName {String} -可选，容器样式，默认为空
         * @param options.domStyle {Object} -可选，容器样式，默认为空
         */
        initialize: function(options) {
            Class.setOptions(this, options);
            this._id = options.id || CommonUtil.newUUID32();
            this.options.domId = this.options.domId || this._id;
            this.options.domHtml = options.label;
            //是否显示
            this._visible = false;
            //
            this._tail = null;
            this._tailArrow = null;
            this._dom = null;
            this._domContainer = null;
            //引线锚点
            this._tailAnchor = null;
            //dom锚点
            this._domAnchor = null;
            //dom的像素范围[minx,miny,maxx,maxy]
            this._domBounds = [];
            //
            this.options.geometry = GeometryUtil.toJstsGeometry(this.options.geometry);
            //
            let domStyle = {
                position: 'absolute',
                display: 'block',
                'white-space': 'nowrap',
                'min-width': this.options.minWidth + 'px',
                'min-height': this.options.minHeight + 'px',
                "font-family": "SimSun"
            };
            this.options.domStyle = jQuery.extend(true, domStyle, this.options.domStyle || {});
            this._domMove = false;
            this._domMoveStart = {};
            //
            this._update();
        },
        update(options) {
            let oldStyleTag = JSON.stringify(this.options.domStyle);
            if (options) {
                jQuery.extend(true, this.options, options);
                // let color = options.lineColor;//split("#")[1];
                // let color_ = g2.sfs.Color.fromHex(color)
                // this.options.symbol = {
                //     "type": "SimpleLineSymbol",
                //     "options": {
                //         "color": {
                //             "a": color_.a,
                //             "r": color_.r,
                //             "g": color_.g,
                //             "b": color_.b
                //         },
                //         "style": "5",
                //         "width": 1
                //     }
                // }
            }

            //更新样式changed
            if (oldStyleTag != JSON.stringify(this.options.domStyle)) {
                for (let styleName in this.options.domStyle) {
                    this._dom.css(styleName, this.options.domStyle[styleName]);
                }
            }
            //
            this._update();
        },
        /**
         * 销毁
         */
        destroy: function() {
            //
            this._unbindDomEvent();
            //
            this._clearTail();
            //
            this._clearDom();
        }
    });
    //对外
    TailedPopup.include({
        getId: function() {
            return this._id;
        },
        /**
         * 更新引线
         */
        updateTail: function() {
            this._clearTail();
            //引线锚点
            this._updateTailAnchor();
            //dom 锚点
            this._updateDomAnchor();
            //
            this._updateTail();
            //箭头
            if (this.options.showArrow === true) {
                this._updateArrow();
            }
        },
        /**
         * 更新dom
         */
        updateDom: function() {
            this._updateTailAnchor();
            this._updateDomAnchor();
            this._updateDomPosition();
        },
        setContent: function(content) {
            this._dom.html(content);
            this.options.domHtml = content;
        },
        /**
         * 获取像素范围，用于处理遮盖关系
         */
        getBounds: function() {
            //计算加上 间隙
            var minGap = this.options.domMinGap;
            var bounds = [];
            bounds.push(this._domBounds[0] - minGap[0]);
            bounds.push(this._domBounds[1] - minGap[1]);
            bounds.push(this._domBounds[2] + minGap[2]);
            bounds.push(this._domBounds[3] + minGap[3]);
            return bounds;
        },
        /**
         * 判断是否与另一个重叠
         * @param tailDom {TailDom}
         * @returns {Boolean}
         */
        intersects: function(tailDom) {
            var domBounds = tailDom.getBounds(),
                thisDomBounds = this.getBounds();
            var envlope = new jsts.geom.Envelope(domBounds[0], domBounds[2],
                    domBounds[1], domBounds[3]),
                thisEnvlope = new jsts.geom.Envelope(thisDomBounds[0], thisDomBounds[2],
                    thisDomBounds[1], thisDomBounds[3]);
            return thisEnvlope.intersects(envlope);
        },
        /**
         * 切换显隐
         * @param visible {Boolean}
         */
        toggleVisible: function(visible) {
            visible = !!visible;
            //dom
            var dom = this._getDom();
            if (visible) {
                dom.css('display', 'block');
            } else {
                dom.css('display', 'none');
            }
            //elements
            var layer = this.options.layer;
            if (this._tail != null) {
                layer.showElement(this._tail, visible);
            }
            if (this._tailArrow != null) {
                layer.showElement(this._tailArrow, visible);
            }
            this._visible = visible;
        },
        visible: function() {
            return this._visible;
        },
        /**
         * 序列化
         */
        serialize: function() {

            let options = jQuery.extend(true, {}, this.options)
            delete options.layer
            delete options.map
            console.log(options);
            return JSON.stringify(options);
        },
    });
    //内部
    TailedPopup.include({
        //dom 容器
        _getDomContainer: function() {
            if (this._domContainer == null) {
                var containerId = this.options.domContainer,
                    container = jQuery('#' + containerId);
                if (container.length == 0) {
                    var html = '<div id="' + containerId + '"';
                    html += 'style="top:0px;left:0px;' +
                        'position:absolute;pointer-events:auto;cursor:pointer"';
                    html += '></div>';
                    jQuery('#' + this.options.map.options.targetId).find('.ol-overlaycontainer-stopevent').append(html);
                }
                this._domContainer = jQuery('#' + containerId);
            }
            return this._domContainer;
        },
        //dom
        _getDom: function() {
            var container = this._getDomContainer(),
                domId = this.options.domId,
                domTag = this.options.domTag;
            if (this._dom == null) {
                var html = '<' + domTag + ' id="' + domId + '"';
                if (this.options.domClassName) {
                    html += ' class="' + this.options.domClassName + '" ';
                }
                if (this.options.domStyle) {
                    let style = '';
                    for (let styleName in this.options.domStyle) {
                        style += styleName + ':' + this.options.domStyle[styleName] + ';';
                    }
                    html += ' style="' + style + '" ';
                }
                html += '></' + domTag + '>';
                container.append(html);
                this._dom = jQuery('#' + domId);
                this._bindDomEvent();
            }
            return this._dom;
        },
        /**
         * 更新引线和dom
         */
        _update: function() {
            this.updateTail();
            this.updateDom();
        },
        //更新dom 位置
        _updateDomPosition: function() {
            var dom = this._getDom(),
                position = this._getDomAnchorPos();
            var width = dom.outerWidth(),
                height = dom.outerHeight(),
                marginLeft = this._domAnchor[2] + position.xVar * width,
                marginTop = this._domAnchor[3] + position.yVar * height;
            dom.css('marginLeft', marginLeft + 'px');
            dom.css('marginTop', marginTop + 'px');
            //
            this._domBounds = [marginLeft, marginTop,
                marginLeft + width, marginTop + height
            ];
            //绘制边界，调试用
            // this._drawBounds();
        },
        //标注边界位置
        _drawBounds: function() {
            if (this._bounds) {
                this.options.layer.remove(this._bounds);
            }
            var coordinates = [],
                map = this.options.map;

            function ppp(list, pixelArr, map) {
                var coor = map.getCoordinateFromPixel(pixelArr);
                list.push(coor);
            }

            var domBounds = this.getBounds();
            ppp(coordinates, [domBounds[0], domBounds[1]], map);
            ppp(coordinates, [domBounds[0], domBounds[3]], map);
            ppp(coordinates, [domBounds[2], domBounds[3]], map);
            ppp(coordinates, [domBounds[2], domBounds[1]], map);
            ppp(coordinates, [domBounds[0], domBounds[1]], map);
            var geom = {
                type: 'Polygon',
                coordinates: [coordinates]
            }
            var symbol = {
                "type": "SimpleFillSymbol",
                "options": {
                    "borderColor": {
                        "a": 120,
                        "r": 255,
                        "g": 0,
                        "b": 0
                    },
                    "fillColor": {
                        "a": 50,
                        "r": 200,
                        "g": 0,
                        "b": 0
                    },
                    "borderThickness": 2,
                    "opacity": 1
                }
            };
            // console.log(symbol);
            this._bounds = RenderUtil.geoinfoToElement(geom, symbol, {
                id: CommonUtil.newUUID32(),
                layer: this.options.layer
            });
        },
        //获取dom 锚点的位置，根据连线角度
        _getDomAnchorPos: function() {
            return {
                xVar: 0,
                yVar: -1
            };
        },
        //获取尾部锚点
        _updateTailAnchor: function() {
            var map = this.options.map,
                geometry = this.options.geometry;
            var center = geometry.getCentroid().coordinate;
            var tailAnchorMap = [center.x, center.y];
            var tailAnchorPixel = map.getPixelFromCoordinate(tailAnchorMap);
            this._tailAnchor = tailAnchorMap.concat(tailAnchorPixel);
        },
        _updateDomAnchor: function() {
            var tailAnchor = this._tailAnchor,
                length = this.options.tailLength,
                angle = this.options.tailAngle;
            var map = this.options.map;
            var rad = (270 + angle) * Math.PI / 180,
                pixelX = tailAnchor[2] + Math.cos(rad) * length,
                pixelY = tailAnchor[3] + Math.sin(rad) * length,
                anchorPixel = [pixelX, pixelY],
                mapAnchor = map.getCoordinateFromPixel(anchorPixel);
            this._domAnchor = mapAnchor.concat(anchorPixel);
        },
        _updateTail: function() {
            var tailAnchor = this._tailAnchor,
                domAnchor = this._domAnchor;
            var line = {
                type: 'LineString',
                coordinates: [
                    [tailAnchor[0], tailAnchor[1]],
                    [domAnchor[0], domAnchor[1]]
                ]
            };

            this._tail = RenderUtil.geoinfoToElement(line, this.options.symbol, {
                id: this._id,
                layer: this.options.layer
            });
        },
        //获取箭头
        _updateArrow: function() {
            var arrowOpts = {},
                map = this.options.map;
            arrowOpts.startPt = this._domAnchor.slice(2);
            arrowOpts.endPt = this._tailAnchor.slice(2);
            arrowOpts.arrowScale = this.options.arrowScale;
            arrowOpts.arrowAngle = this.options.arrowAngle;
            arrowOpts.arrowLength = this.options.arrowLength;
            var arrowPointsPixel = MathUtil.getSimpleArrow(arrowOpts);
            var arrowPoints = [];
            for (var i = 0, len = arrowPointsPixel.length; i < len; i++) {
                var pixelPoint = arrowPointsPixel[i];
                var point = map.getCoordinateFromPixel(pixelPoint);
                arrowPoints.push(point);
            }
            //
            var map = {
                //线
                'line': function(arrowPoints) {
                    var arrowGeoJson = {
                        type: 'LineString',
                        coordinates: arrowPoints
                    };
                    var symbol = this.options.arrowSymbol || this.options.symbol;
                    return {
                        geometry: arrowGeoJson,
                        symbol: symbol
                    };
                },
                //三角
                'triangle': function(arrowPoints) {
                    arrowPoints.push(arrowPoints[0]);
                    var arrowGeoJson = {
                        type: 'Polygon',
                        coordinates: [arrowPoints]
                    };
                    var symbol;
                    if (this.options.arrowSymbol) {
                        symbol = this.options.arrowSymbol;
                    } else {
                        //自动继承引线颜色
                        symbol = {
                            "type": "SimpleFillSymbol",
                            "options": {
                                "borderColor": {
                                    "a": 1,
                                    "r": 0,
                                    "g": 0,
                                    "b": 0
                                },
                                "fillColor": {},
                                "opacity": 1
                            }
                        }
                        var symbolOpts = this.options.symbol.options;
                        symbol.options.fillColor = symbolOpts.fillColor ||
                            symbolOpts.color;
                    }
                    return {
                        geometry: arrowGeoJson,
                        symbol: symbol
                    };
                }
            };
            //如果是线
            var fn = map[this.options.arrowShape] || map['triangle'];
            var object = fn.call(this, arrowPoints);
            this._tailArrow = RenderUtil.geoinfoToElement(object.geometry, object.symbol, {
                id: this._id + '_arrow',
                layer: this.options.layer
            });
        },
        //开启拖动dom
        _moveDomStart: function(e) {
            this._domMove = true;
            e.preventDefault();
            e.stopPropagation();

            // this.options.map.stopDragPan();
            this._domMoveStart.disX = e.pageX - this._dom.offset().left;
            this._domMoveStart.disY = e.pageY - this._dom.offset().top;
        },
        //拖动dom中
        _moveDomMove: function(e) {
            if (this._domMove) {
                let curMarginleft = e.pageX - this._domMoveStart.disX,
                    curMarginTop = e.pageY - this._domMoveStart.disY;
                this._dom.css({
                    "marginLeft": curMarginleft,
                    "marginTop": curMarginTop
                });
                let dom = this._getDom(),
                    position = this._getDomAnchorPos();
                let width = dom.outerWidth(),
                    height = dom.outerHeight();
                let domX = curMarginleft - position.xVar * width;
                let domY = curMarginTop - position.yVar * height;
                let map = this.options.map;
                let anchorPixel = [domX, domY];
                let mapAnchor = map.getCoordinateFromPixel(anchorPixel);
                this._domAnchor = mapAnchor.concat(anchorPixel);
                this._domBounds = [curMarginleft, curMarginTop,
                    curMarginleft + width, curMarginTop + height
                ];
                let tailAnchor = this._tailAnchor;
                let y_ = tailAnchor[3] - domY,
                    x_ = tailAnchor[2] - domX;
                let rad = Math.atan(Math.abs(y_ / x_));
                let angle = 180 / Math.PI * rad;
                let angle_;
                if (y_ < 0 && x_ < 0) {
                    angle_ = angle + 90;
                } else if (y_ > 0 && x_ < 0) {
                    angle_ = 90 - angle;
                } else if (y_ < 0 && x_ > 0) {
                    angle_ = 270 - angle;
                } else if (y_ > 0 && x_ > 0) {
                    angle_ = 270 + angle;
                } else if (y_ == 0 && x < 0) {
                    angle_ = 90;
                } else if (y_ == 0 && x > 0) {
                    angle_ = 270;
                } else if (y_ < 0 && x == 0) {
                    angle_ = 180;
                } else if (y_ > 0 && x == 0) {
                    angle_ = 0;
                }
                let length = Math.sqrt(x_ * x_ + y_ * y_);
                this.options.tailLength = length;
                this.options.tailAngle = angle_;
                this._clearTail();
                this._updateTail();
            }
        },
        _moveDomEnd: function() {
            this._domMove = false;
            this.fire('updateTailedLabelAttr')
        },
        _domMoveMapMove: function(screenX, screenY) {
            if (this._domMove) {
                let curMarginleft = screenX - this._domMoveStart.disX,
                    curMarginTop = screenY - this._domMoveStart.disY;
                this._dom.css({
                    "marginLeft": curMarginleft,
                    "marginTop": curMarginTop
                });
                let dom = this._getDom(),
                    position = this._getDomAnchorPos();
                let width = dom.outerWidth(),
                    height = dom.outerHeight();
                let domX = curMarginleft - position.xVar * width;
                let domY = curMarginTop - position.yVar * height;
                let map = this.options.map;
                let anchorPixel = [domX, domY];
                let mapAnchor = map.getCoordinateFromPixel(anchorPixel);
                this._domAnchor = mapAnchor.concat(anchorPixel);
                this._domBounds = [curMarginleft, curMarginTop,
                    curMarginleft + width, curMarginTop + height
                ];

                // let point = new g2.sfs.Point({
                //     x: this._domAnchor[0],
                //     y: this._domAnchor[1],
                //     spatialReference: map.spatialReference
                // });
                // let markerSymbol = new g2.sfs.SimpleMarkerSymbol({
                //     offsetX: 0,
                //     offsetY: 0,
                //     fillColor: new g2.sfs.Color({a: 255, r: 0, g: 0, b: 0}),
                //     size: 3
                // });
                // let pointEle = new g2.sfs.Element({geometry: point, symbol: markerSymbol});
                // this.options.layer.add(pointEle)
                // let domY = this._domAnchor[3], domX = this._domAnchor[2];
                let tailAnchor = this._tailAnchor;
                let y_ = tailAnchor[3] - domY;

                let x_ = tailAnchor[2] - domX;
                let rad = Math.atan(Math.abs(y_ / x_));
                let angle = 180 / Math.PI * rad;
                let angle_;
                if (y_ < 0 && x_ < 0) {
                    angle_ = angle + 90;
                } else if (y_ > 0 && x_ < 0) {
                    angle_ = 90 - angle;
                } else if (y_ < 0 && x_ > 0) {
                    angle_ = 270 - angle;
                } else if (y_ > 0 && x_ > 0) {
                    angle_ = 270 + angle;
                } else if (y_ == 0 && x < 0) {
                    angle_ = 90;
                } else if (y_ == 0 && x > 0) {
                    angle_ = 270;
                } else if (y_ < 0 && x == 0) {
                    angle_ = 180;
                } else if (y_ > 0 && x == 0) {
                    angle_ = 0;
                }
                let length = Math.sqrt(x_ * x_ + y_ * y_);
                this.options.tailLength = length;
                this.options.tailAngle = angle_;
                this._clearTail();
                this._updateTail();
            }
        },
        _changeDomLabel: function() {
            // this.setContent("拖动改变颜色")
            // this.update({domStyle:{background:"#458B74"}});
        },
        _clearTail: function() {
            if (this._tail != null) {
                this.options.layer.remove(this._tail);
                this._tail = null;
            }
            if (this._tailArrow != null) {
                this.options.layer.remove(this._tailArrow);
                this._tailArrow = null;
            }
        },
        _clearDom: function() {
            if (this._dom != null) {
                this._dom.remove();
            }
        },
        //监听事件
        _bindDomEvent: function() {

            this._dom.on('mousedown', (event) => {
                this.mousedownTime = new Date().getTime();
                // this._changeDomLabel();
                this._moveDomStart(event);
                this.options.map.listen('mousemove', (e) => {
                    this._domMoveMapMove(e.screenX, e.screenY)
                });
                // this.options.map.listen('mousemove',this._domMoveMapMove);

                this.options.map.listen('mouseup', (e) => {
                    this._moveDomEnd(e)
                        // this.options.map.off('mousemove',this._domMoveMapMove);
                });

            });

            // this._dom.on('mousemove', (event) => {
            //     this._moveDomMove(event);
            //
            // });
            // this._dom.on('mouseover', (event) => {
            //
            // });
            this._dom.on('mouseup', (event) => {
                this.mouseUpTime = new Date().getTime();
                this._moveDomEnd();

                this.options.map.off('mousemove');
                this.options.map.off('mouseup');
            })

            this._dom.on('click', (event) => {
                if ((this.mouseUpTime - this.mousedownTime) < 200) {
                    this.fire('tailedLabelClick')
                }

            })
        },
        _unbindDomEvent: function() {
            this._dom.off('mousedown');
            this._dom.off('mousemove');
            this._dom.off('mouseup')
            this._dom.off('click')
        }
    });
    return TailedPopup;
});